import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation signUpUser(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $referralCode: String
  ) {
    signUpUser(
      email: $email
      password: $password
      firstName: $firstName
      lastName: $lastName
      referralCode: $referralCode
    ) {
      success
      message
      user {
        id
        fullName
        email
        userType
      }
    }
  }
`

export interface SignUpInput {
  email: string
  password: string
  firstName: string
  lastName: string
  referralCode?: string
}

export interface SignUpOutput {
  signUpUser: {
    success: boolean
    message: string
    user: {
      id: string
      fullName: string
      email: string
      userType: string
    }
  }
}

export const useSignUp = () => useMutation<SignUpOutput, SignUpInput>(mutation)
